import { useCountryConfig } from '../../hooks/use-country-config';
import { CountryConfigNames } from '../../contexts/country-config-context/country-config-enums';
import { useEnableSupplyPage } from './use-enable-supply-page';

export const useEnableSuppliesNav = () => {
  const [shippingSuppliesLinkEnabled] = useCountryConfig(CountryConfigNames.ShippingSuppliesLinkEnabled);
  const enableSupplyPage = useEnableSupplyPage();
  return shippingSuppliesLinkEnabled && enableSupplyPage;
};
